import { StyleSheet } from 'aphrodite/no-important';
import { color, fontWeight } from '../../../shared/styles/vars';
import { media } from '../../../shared/styles/constants';

export const styles = StyleSheet.create({
    imgOverlay: {
        position: 'relative',
    },

    playCont: {
        display: 'inline-flex',
        alignItems: 'center',
        width: '100%',
        height: '32px',
        position: 'absolute',
        bottom: 0,
    },

    playIcon: {
		bottom: '0',
		width: '32px',
		height: '32px',
		display: 'inline-flex',
		alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        zIndex: 1,
    },

    durationContainer: {
		position: 'absolute',
        left: 28,
        height: 15,
        display: 'block'
	},
	duration: {
		backgroundColor: 'rgba(0, 0, 0, 0.75)',
		height: '100%',
		position: 'relative',
		fontSize: '10px',
		fontWeight: fontWeight.bold,
		color: color.white,
		paddingLeft: '6px',
		paddingRight: '5px',
		borderTopRightRadius: '2px',
        borderBottomRightRadius: '2px',
        display: 'block',

		':after': {
			content: '""',
			position: 'absolute',
			width: '18px',
			top: '0',
			bottom: '0',
			right: '100%',
			backgroundColor: 'transparent',
			borderTopRightRadius: '25% 11px',
			borderBottomRightRadius: '25% 11px',
			boxShadow: '14px 0px 0px 0px rgba(0, 0, 0, 0.75)',
			clip: 'rect(0px, 18px, 18px, 0px)'
		}
	},

    bkColor: {
        backgroundColor: 'rgba(0,0,0,.7)',
    },

    videoLength: {
        color: color.white,
        fontFamily: 'Antenna',
        fontSize: '10px',
        fontWeight: fontWeight.bold,
        lineHeight: .7,
        backgroundColor: 'rgba(0,0,0,.7)',
        borderRadius: '2px',
        padding: '5px 5px 5px 8px',
        display: 'inline-block',
        position: 'absolute',
        left: '24px',
        zIndex: 0,
        
    },
    
    videoTplCont: {
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        position: 'relative',
        marginBottom: '10px',
        backgroundColor: color.cobaltBlueLight,
    },

    thumbOverlay : {
        position: 'absolute',
        height: '100%',
        width: '100%',
        opacity: 0.05,
        backgroundColor: color.lightGray,
        zIndex: -1,
    },

    thumbOverlayActive: {
    },

    imgThumb: {
        width: '150px',
        maxHeight: '84px',


        [media.LAPTOP]: {
            width: 125,
            height: 70
        },

        [media.TABLET]: {
            width: 95,
            height: 53
        },

        display: 'block',
    },

    meta: { 
        margin: '0 10px'
    },

    thumbTitle: {
        fontFamily: 'Antenna',
        fontSize: 11,
        fontWeight: fontWeight.semibold,
        lineHeight: 1.27,
        textAlign: 'left',
        marginTop: '4px',
        color: color.white,
        display: 'block'
    },

    thumbTitleActive: {
        color: '#2c394c',        
    },

    upNext: {
        borderRadius: '2px',
        backgroundColor: color.white,
        color: color.pickledBluewood,
        padding: '1px 4px',
        fontFamily: 'Arial',
        fontSize: '9px',
        fontWeight: 'bold',
    },
    zIndexOne: {
		zIndex: '1'
	},
});